<template>
    <div class="col-12" :style="backgroundObject">
        <template v-if="user">
            <user-table-item :open="user.open"
                             :showIcon="user.dependents && user.dependents.length > 0"
                             :user="user"
                             @open="$set(user, 'open', !user.open)"
                             @showShops="showShops = !showShops"
                             @changeTab="$emit('changeTab', $event)"/>
            <transition name="slide-up" mode="out-in">
                <shops-table :userTableView="true"
                             :userShops="user.shops"
                             :hideAddition="true"
                             :user="user"
                             @editShop="editShop(shop)"
                             @changeTab="$emit('changeTab', $event)"
                             @addUserToShop="$emit('addUserToShop', $event)"
                             @removeShopFromUser="handleUserRemoval"
                             v-if="showShops && user.shops && user.shops.length > 0"/>
            </transition>
            <transition-group name="slide-up"
                              mode="out-in"
                              tag="div"
                              class="row py-0"
                              v-if="user.dependents">
                <template v-if="user.open">
                    <user-table-row :open="depenedent.open"
                                    :user.sync="depenedent"
                                    :level="level + 1"
                                    :showIcon="depenedent.dependents
                                            && depenedent.dependents.length > 0"
                                    :key="'tbl-row' + depenedent.id"
                                    @changeTab="$emit('changeTab', $event)"
                                    @open="$set(depenedent, 'open', !depenedent.open)"
                                    v-for="depenedent in user.dependents"/>
                </template>
            </transition-group>
        </template>
    </div>
</template>
<script type="text/babel">
import UserTableItem from './UserTableItem';
import ShopsTable from '../Shops/ShopsTable';
import { mapActions, mapMutations } from 'vuex';
import {EventBus} from '@/eventbus';

export default {
    name: 'user-table-row',
    components: {
        UserTableItem,
        ShopsTable
    },
    data () {
        return {
            open: false,
            children: [],
            showShops: false
        };
    },
    props: {
        user: {
            type: [Array, Object]
        },
        level: {
            default: 0
        }
    },
    computed: {
        backgroundObject () {
            switch (this.level) {
                case 0: return {'background-color': '#ffffff'};
                case 1: return {'background-color': '#e3e3e3'};
                case 2: return {'background-color': '#c4c4c4'};
                case 3: return {'background-color': '#505050', 'color': '#fff'};
                case 4: return {'background-color': '#000000', 'color': '#fff'};
            }
        }
    },
    methods: {
        ...mapMutations(['updateUserShopList']),
        ...mapActions([
            'GetChildrenFromUser',
            'GetUser',
            'GetShopFromUser',
            'GetShopById',
            'DelShopFromUser',
            'GetAllUsers'
        ]),
        editShop (shop) {
            this.$emit('changeTab', {name: 'ShopRegister', data: shop});
        },
        async fetchShops () {
            try {
                let { data } = await this.GetShopFromUser({id: this.user.id});
                if(typeof data === 'string') {
                    data = [data];
                }
                let shops = data ? this.$utils.flatten(
                    await this.$utils.resolvePromises(
                        data.filter(item => item)
                            .map(shop => this.GetShopById(shop))
                    )
                ) : [];
                this.$set(this.user, 'shops', shops);
                this.$emit('update:user', {...this.user, shops});
            } catch (err) {
                console.error(err);
            }
        },
        async handleUserRemoval (shopId) {
            try {
                await this.DelShopFromUser({id: this.user.id, shopId: shopId});
                EventBus.$emit('updateUserList');
            } catch (err) {
                console.log(err);
            }
        }
    },
    created () {
        if(this.user) {
            this.fetchShops();
        }
    }
};

</script>
